import { CSS } from '@dnd-kit/utilities';
import { useSortable } from '@dnd-kit/sortable';

export default function SortableItem({ id, children, isDisabled }) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id, disabled: isDisabled });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        cursor: isDisabled ? 'default' : 'move',  // Change cursor
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
        {children}
        </div>
    );
}
